module.exports = __webpack_public_path__ + "img/paper-2.0e6c7768.png";